import { Outlet, RouteObject, useRoutes } from "react-router-dom";
import { layoutsList } from "../routes";
import NotFound from "./NotFound";
import Route from "./Route";
import {Fragment} from 'react'
import ParentMiddleware from './ParentMiddleware'

export default function Routes() {
  let routesList: RouteObject[] = [];

  layoutsList.map((layout) => {
    const { LayoutComponent, routes } = layout;

    const layoutRoutes: RouteObject = {
      element: <ParentMiddleware layout={layout} />,
      children: [],
    };

    routes.map((route) => {
      const childrenRoute: RouteObject = {
        path: route.path,
        element: <Route route={route} />,
      };

      layoutRoutes.children!.push(childrenRoute);
    });

    routesList.push(layoutRoutes);
  });


  // Not Found Component
  routesList.push({
    path: "*",
    element: <NotFound />,
  });

  return useRoutes(routesList);
}
